import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle } from "lucide-react";

export default function UnsubscribeSearchPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    api.get(`/saved-searches/unsubscribe/${token}`)
      .then(() => setStatus("done"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="unsubscribe-search-page">
      {status === "loading" && <p className="text-gray-500">Unsubscribing…</p>}
      {status === "done" && (
        <>
          <CheckCircle2 size={44} className="text-emerald-600 mx-auto mb-4" />
          <h1 className="font-display text-3xl brand-forest mb-2">You're unsubscribed</h1>
          <p className="text-gray-600 mb-8">You won't get any more emails for this saved search.</p>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle size={44} className="text-red-500 mx-auto mb-4" />
          <h1 className="font-display text-3xl brand-forest mb-2">Link not found</h1>
          <p className="text-gray-600 mb-8">This alert may already be removed.</p>
        </>
      )}
      {status !== "loading" && (
        <Link to="/properties">
          <Button className="tlr-gold-btn rounded-full h-11 px-6" data-testid="unsubscribe-browse-btn">Browse properties</Button>
        </Link>
      )}
    </div>
  );
}
